import { Component, inject, signal } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { GenericFormComponent } from '../../../../../shared/components/generic-form/generic-form.component';
import { AuthService } from '../../../../../core/auth/auth.service';
import { AlertService } from '../../../../../shared/services/alert.service';

@Component({
  selector: 'app-forgot-password-form',
  standalone: true,
  imports: [ReactiveFormsModule, RouterLink, GenericFormComponent],
  templateUrl: './forgot-password-form.component.html',
  styleUrl: './forgot-password-form.component.css',
})
export class ForgotPasswordFormComponent {
  private authService: AuthService = inject(AuthService);
  private router: Router = inject(Router);
  private fb: FormBuilder = inject(FormBuilder);
  private alertService: AlertService = inject(AlertService);

  forgotPasswordForm: FormGroup = this.fb.group({
    email: ['', [Validators.required, Validators.email]],
  });

  isLoading = signal(false);
  successMessage = signal<string | null>(null);
  errorMessage = signal<string | null>(null);

  onSubmit(): void {
    if (this.forgotPasswordForm.invalid) {
      this.forgotPasswordForm.markAllAsTouched();
      return;
    }

    this.isLoading.set(true);
    this.successMessage.set(null);
    this.errorMessage.set(null);

    const email = this.forgotPasswordForm.value.email;

    const base = document.querySelector('base');
    const baseHref = base?.getAttribute('href') || '/';
    const contextPath = baseHref.replace(/\/+$/, '');
    const baseUrl = `${window.location.origin}${contextPath}`;

    this.authService.requestPasswordReset(email, baseUrl).subscribe({
      next: (response) => {
        this.isLoading.set(false);
        const msg = response.data || response.message || 'Se l\'email inserita è presente nei nostri sistemi, riceverai le istruzioni per il reset della password.';
        this.successMessage.set(msg);
        this.alertService.showSuccess(msg);
      },
      error: (err) => {
        this.isLoading.set(false);
        const errStr = err?.error?.message || 'Si è verificato un errore durante la richiesta.';
        this.errorMessage.set(errStr);
      },
    });
  }
}
